import { createContext, useContext } from "react";
import type { IdentityProviderName } from "./idpSession";

/** El `user` que la app lee: los claims del ID token, como los entregaba Auth0. */
export interface IdentityUser {
  sub?: string;
  name?: string;
  email?: string;
  picture?: string;
  nickname?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [claim: string]: any;
}

/**
 * Lo que la app consume de la identidad: el subconjunto de `useAuth0()` que usa hoy. Lo
 * alimenta Auth0Bridge (tal cual) o CognitoBridge (adaptado), según el flag de la sesión.
 */
export interface Identity {
  provider: IdentityProviderName;
  user?: IdentityUser;
  isAuthenticated: boolean;
  isLoading: boolean;
  error?: Error;
  getAccessTokenSilently: () => Promise<string>;
  loginWithRedirect: (options?: { appState?: unknown }) => Promise<void>;
  logout: (options?: { logoutParams?: { returnTo?: string } }) => Promise<void>;
}

export const IdentityContext = createContext<Identity | null>(null);

export function useIdentity(): Identity {
  const identity = useContext(IdentityContext);
  if (!identity) throw new Error("useIdentity fuera de AppAuthProvider");
  return identity;
}
